interface PaginationProps {
  itemsPerPage: number
  totalItems: number
  onPageChange: (page: number) => void
  currentPage: number
  setRowsPerPage: (limit: number) => void
  itemsLength: number
  setPage: (page: number) => void
  rowsPrPageList?: number[]
}

const Pagination: React.FC<PaginationProps> = ({
  itemsPerPage,
  totalItems,
  onPageChange,
  currentPage,
  setRowsPerPage,
  itemsLength,
  setPage,
  rowsPrPageList,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const handlePageChange = (page: number) => {
    onPageChange(page)
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1)
    }
  }

  const handlePrevPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1)
    }
  }

  const renderDots = () => {
    const dots = []

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        dots.push(
          <li key={i} className='page-item'>
            <button
              className={`page-link ${
                i === currentPage ? "active bg-primary text-white border-primary" : ""
              }`}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </button>
          </li>,
        )
      }
    } else {
      const startPage = Math.max(1, currentPage - 2)
      const endPage = Math.min(totalPages, currentPage + 2)

      if (startPage > 1) {
        dots.push(
          <li key='start' className='page-item'>
            <button className='page-link' onClick={() => handlePageChange(1)}>
              1
            </button>
          </li>,
        )
        if (startPage > 2) {
          dots.push(
            <li key='ellipsis-start' className='page-item disabled'>
              <span className='page-link'>...</span>
            </li>,
          )
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        dots.push(
          <li key={i} className='page-item'>
            <button
              className={`page-link ${
                i === currentPage ? "active bg-primary text-white border-primary" : ""
              }`}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </button>
          </li>,
        )
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          dots.push(
            <li key='ellipsis-end' className='page-item disabled'>
              <span className='page-link'>...</span>
            </li>,
          )
        }
        dots.push(
          <li key='end' className='page-item'>
            <button className='page-link' onClick={() => handlePageChange(totalPages)}>
              {totalPages}
            </button>
          </li>,
        )
      }
    }

    return dots
  }

  const option =
    rowsPrPageList && rowsPrPageList.length > 0 ? rowsPrPageList : [10, 20, 25, 50, 100]

  return (
    <div className='table-pagination-section'>
      <div>
        <h5 className='table-pagination-info'>
          Showing&nbsp;
          <span>{currentPage * itemsPerPage - itemsPerPage + 1}</span>&nbsp; to&nbsp;
          <span>{currentPage * itemsPerPage - itemsPerPage + itemsLength}</span>
          &nbsp; of&nbsp; <span>{totalItems}</span> &nbsp;Results
        </h5>
      </div>

      <div className='table-pagination-right'>
        <select
          className='form-select form-select-sm table-pagination-dropdown'
          style={{ width: "auto" }}
          value={itemsPerPage}
          onChange={(e) => {
            setRowsPerPage(Number(e.target.value))
            setPage(1)
          }}
        >
          {option.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>

        <ul className='pagination-list'>
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button className='page-link d-flex align-items-center gap-1' onClick={handlePrevPage}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                strokeWidth={1.5}
                stroke='currentColor'
                className='size-6'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M15.75 19.5 8.25 12l7.5-7.5'
                />
              </svg>
            </button>
          </li>

          {renderDots()}

          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
            <button className='page-link d-flex align-items-center gap-1' onClick={handleNextPage}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                strokeWidth={1.5}
                stroke='currentColor'
                className='size-6'
              >
                <path strokeLinecap='round' strokeLinejoin='round' d='m8.25 4.5 7.5 7.5-7.5 7.5' />
              </svg>
            </button>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Pagination
